import Vue from 'vue'
import Router from 'vue-router'

import ActionBase from '../views/ActionBase'
import Home from '../views/Home'
import Login from '../views/Login'
import Lost from '../views/Lost'
import PasswordReset from '../views/PasswordReset'
import PasswordResetConfirm from '../views/PasswordResetConfirm'
import BuildingStockSummary from '../views/BuildingStockSummary'
import BuildingStockSites from '../views/BuildingStockSites'
import BuildingStockRenewableEnergies from '../views/BuildingStockRenewableEnergies'
import BuildingStockFileImport from '../views/BuildingStockFileImport'
import BuildingStockSiteDetails from '../views/BuildingStockSiteDetails'
import BuildingStockSiteBuildings from '../views/BuildingStockSiteBuildings'
import ScenarioList from '../views/ScenarioList'
import ScenarioRefine from '../views/ScenarioRefine'
import ScenarioResults from '../views/ScenarioResults'
import ScenarioScript from '../views/ScenarioScript'
import ScenarioProgram from '../views/ScenarioProgram'
import ScenarioSettings from '../views/ScenarioSettings'
import PPIList from '../views/PPIList'
import AtypicalList from '../views/AtypicalList'

import store from '../store'

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login')
      } else {
        next()
      }
    })
}

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/home')
      } else {
        next()
      }
    })
}

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .finally(() => next('/login'))
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: requireAuthenticated,
      component: Home
    },
    {
      path: '/scenario',
      name: 'Scenarios',
      redirect: '/scenario/list'
    },
    {
      path: '/scenario/list',
      name: 'Scenarios list',
      beforeEnter: requireAuthenticated,
      component: ScenarioList
    },
    {
      path: '/scenario/:scenarioId/settings',
      name: 'Scenario settings',
      beforeEnter: requireAuthenticated,
      component: ScenarioSettings
    },
    {
      path: '/scenario/:scenarioId/script',
      name: 'Scenario script',
      beforeEnter: requireAuthenticated,
      component: ScenarioScript
    },
    {
      path: '/scenario/:scenarioId/program',
      name: 'Scenario program',
      beforeEnter: requireAuthenticated,
      component: ScenarioProgram
    },
    {
      path: '/scenario/:scenarioId/results',
      name: 'Scenario results',
      beforeEnter: requireAuthenticated,
      component: ScenarioResults
    },
    {
      path: '/scenario/:scenarioId/refine',
      name: 'Scenario refine',
      beforeEnter: requireAuthenticated,
      component: ScenarioRefine
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: requireUnauthenticated
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: redirectLogout
    },
    {
      path: '/password_reset',
      name: 'Password reset',
      component: PasswordReset
    },
    {
      path: '/password_reset/:uid/:token',
      name: 'Password reset confirm',
      component: PasswordResetConfirm
    },
    {
      path: '*',
      component: Lost
    },
    {
      path: '/building-stock',
      name: 'Building stock',
      redirect: '/building-stock/summary'
    },
    {
      path: '/building-stock/summary',
      name: 'Building stock summary',
      beforeEnter: requireAuthenticated,
      component: BuildingStockSummary
    },
    {
      path: '/building-stock/sites',
      name: 'Building stock sites',
      beforeEnter: requireAuthenticated,
      component: BuildingStockSites
    },
    {
      path: '/building-stock/renewable-energies',
      name: 'Building stock renewable energies',
      beforeEnter: requireAuthenticated,
      component: BuildingStockRenewableEnergies
    },
    {
      path: '/building-stock/file-import',
      name: 'Building stock file import',
      beforeEnter: requireAuthenticated,
      component: BuildingStockFileImport
    },
    {
      path: '/building-stock/site/:siteId/summary',
      name: 'Building stock site',
      beforeEnter: requireAuthenticated,
      component: BuildingStockSiteDetails
    },
    {
      path: '/building-stock/site/:siteId/buildings',
      name: 'Building stock site buildings',
      beforeEnter: requireAuthenticated,
      component: BuildingStockSiteBuildings
    },
    {
      path: '/ppi',
      name: 'PPI',
      beforeEnter: requireAuthenticated,
      component: PPIList
    },
    {
      path: '/apytical',
      name: 'Atypical',
      beforeEnter: requireAuthenticated,
      component: AtypicalList
    },
    {
      path: '/actions-base',
      name: 'Base d\'actions',
      beforeEnter: requireAuthenticated,
      component: ActionBase
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js